module.exports = __webpack_public_path__ + "img/eyes_female_extra_thin_mask.8f4ecaea.png";